<template>
    <div class="gallery-list">
        <v-btn icon x-large class="mx-6 mt-n3" color="white" @click="close()"><v-icon>arrow_back</v-icon></v-btn>
        <span class="titulo mt-8">{{gallery.nome}}</span>
        <v-progress-circular class="progress" color="white" size="90" indeterminate v-if="!loaded"></v-progress-circular>
        <VuePictureSwipe v-if="loaded" :items="photos" :options="{shareEl: false}"></VuePictureSwipe> 
    </div>
</template>

<script>
import VuePictureSwipe from 'vue-picture-swipe';
import { setTimeout } from 'timers';

export default {
  name: 'galleryList',
  components: {
    VuePictureSwipe
  },
  props: {
    gallery: {
        type: Object
    },
    opened: {
        type: Boolean
    }, 
  },
  data() {
    return {
        photos: [],
        loaded: false,
        scale: null
    }
  },
  mounted() {
    let vm = this;
    this.gallery.fotos.forEach(element => {
        let photo = {
            src: element.url,
            thumbnail: element.url,
            w: 1280,
            h: 900
        }

        vm.photos.push(photo);
    });
    setTimeout(() => vm.loaded = true, 500)
  },
  methods: {
      close(){
          this.$emit('update:activeGallery', null)
      }
  },
}
</script>

<style lang="scss">
    .gallery-list {
        position: absolute;
        height: 1080px;
        width: 1415px;
        overflow: auto;
        background: #1d52d8c2;
        .titulo {
            font-size: 36px;
            text-transform: uppercase;
            color: white;
            display: inline-block;
        }
        .progress {
            top: 490px;
            left: 650px;
            position: absolute;
        }
    }
    .pswp__button, .pswp__button--arrow--left:before, .pswp__button--arrow--right:before {
        transform: scale(1.4);
        margin: 10px;
    }
    .pswp__counter {
        font-size: 24px;
        margin: 20px;
    }
    .my-gallery {
        padding: 30px;
        width: 1215px;
        figure {
            width: 380px;
            position: relative;
            float: left;
            padding: 5px;
            margin: 0;
            height: 255px;
            overflow: hidden;
            img {
                width: 100%;
            }
        }
    }
</style>
